const COOKIE_REGEXP = /(?:^|;\s*)xing_csrf_token=([^;]+)/;

export const getCSRFToken = (): string => {
  const csrfTokenMatch = window.document.cookie.match(COOKIE_REGEXP);
  return csrfTokenMatch ? csrfTokenMatch[1] : '';
};
